<template>
  <div>
    <v-card class="reset">
      <v-card-title>
        {{ $t('pages.forgotpassword.title') }}
      </v-card-title>
      <v-card-text>
        <form @submit.prevent="submit()">
          <text-input
            v-if="!platformName"
            v-model="form.platformName"
            :config="{ required: true, label: $t('pages.forgotpassword.labels.platformName'), suffix: 'liveconsult.io' }">
          </text-input>
          <text-input
            key="email"
            :config="{ type: 'email', required: true, label: $t('pages.forgotpassword.labels.email') }"
            v-model="form.email">
          </text-input>
          <v-btn
            type="submit"
            primary light block ripple
            :loading="loading">
            {{ $t('pages.forgotpassword.reset') }}
          </v-btn>
        </form>
      </v-card-text>
    </v-card>
    <v-snackbar success v-model="success" multi-line :timeout="2000">
      {{ $t('pages.forgotpassword.success') }}
    </v-snackbar>
    <v-btn block flat light router :href="{ name: 'Login' }">{{ $t('pages.forgotpassword.login') }}</v-btn>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { TextInput } from '@/components/inputs'
  export default {
    components: {
      TextInput
    },
    data () {
      return {
        success: false,
        form: {
          email: null
        }
      }
    },
    computed: {
      ...mapGetters({
        platformName: 'application/platformName',
        loading: 'skiliko/password/isLoading'
      })
    },
    methods: {
      ...mapActions({
        sendEmail: 'skiliko/password/sendEmail'
      }),
      submit () {
        const data = { ...this.form }
        data.platformName = data.platformName || this.platformName
        this.sendEmail(data)
          .then(_ => (this.success = true))
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .reset {
    width: 350px;
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ForgotPassword.vue